import React, { useState, useContext } from 'react';
import './EditCitation.style.scss';
// import { DayPicker } from 'react-day-picker';
// import 'react-day-picker/dist/style.css';
import { AccountContext } from '../../../../Contexts/main.context';





const EditCitationModal = ({ citation, onClose }) => {

     const context = useContext(AccountContext);
     const { activeClient, } = context || {};

     const parseFollowUpDate = (rawDate) => {
          if (
               !rawDate ||
               rawDate === '0000-00-00' ||
               rawDate === '2010-01-01'
          ) {
               return null;
          }
          return new Date(rawDate);
     };

     const [formData, setFormData] = useState({
          ...citation,
          followUpDate: parseFollowUpDate(citation.followUpDate),
     });

     const [copyClicked, setCopyClicked] = useState('');


     // const handleChange = (e) => {
     //      const { name, value } = e.target;
     //      setFormData(prev => ({ ...prev, [name]: value }));
     // };

     const handleSave = () => {

          const payload = {
               ...formData,
               script: "updateCitation"
          };
          // Fire-and-forget: send the data but don’t wait for a response
          fetch("https://www.lgfantasy.ca/Citations/PHP/special.php", {
               method: "POST",
               headers: {
                    "Content-Type": "application/json"
               },
               body: JSON.stringify(payload)
          }).catch(err => console.error("Send failed:", err));

          onClose(); // Close modal immediately
     };


     const handleCopy = (fieldName, value) => {
          navigator.clipboard.writeText(value)
               .then(() => {
                    setCopyClicked(fieldName);
               })
               .catch(err => {
                    console.error('Failed to copy:', err);
               });
     };

     const fillDataFromAccount = () => {
          setFormData(prev => ({
               ...prev,
               BusinessName: activeClient.companyName || '',
               cistationAddress: activeClient.address || '',
               PostalCode: activeClient.postal || '',
               PhoneNumber: activeClient.phone || '',
          }));
     };

     const verifyNAPData = () => {
          alert('This will Check NAP Data once Trevor Approves New API for Searching. Pressing any of the Verify will Verify Each of the 4 NAP Fields');
     }



     // const ignoreList = ["DomainAuthority", "KeyCitation", "TypeOfSite", "FreePaidListing", "ID", "ClientID", "CompetitorsWithCitations", "AlternativeBusinessName", "GeneralStatus", "BusinessName"]; // Add any other keys you want to ignore

     return (
          <div className="custom-modal-backdrop">
               <div className="container alert-light p-4 rounded">
                    <div className="bg-navy p-3 mb-3 d-flex justify-content-center">
                         <h5 className="text-center text-lemon fw-bold">Citation Information</h5>
                    </div>

                    {formData && (
                         <>
                              {/* Row 1 */}
                              <div className="row g-3 mb-3">
                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Status</label>
                                        <select
                                             className="form-control"
                                             name="citationStatus"
                                             value={formData.citationStatus}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, citationStatus: e.target.value }))
                                             }
                                        >
                                             <option value="Active">Active</option>
                                             <option value="Edit">Edit</option>
                                             <option value="Dead">Dead</option>
                                             <option value="Pending">Pending</option>
                                        </select>
                                   </div>


                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Domain</label>
                                        <input
                                             className="form-control"
                                             type="text"
                                             name="Domain"
                                             value={formData.Domain}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, Domain: e.target.value }))
                                             }
                                        />
                                   </div>
                              </div>

                              {/* Row 2 (add more fields here) */}
                              <div className="row g-3 mb-3">
                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Citation Date</label>
                                        <div className="d-flex gap-2">
                                             <div className="col-8">
                                                  <input
                                                       className="form-control"
                                                       type="text"
                                                       name="citationYear"
                                                       value={formData.citationYear}
                                                       onChange={(e) =>
                                                            setFormData(prev => ({ ...prev, citationStatus: e.target.value }))
                                                       }
                                                  />
                                             </div>
                                             <div className="col-8">
                                                  <input
                                                       className="form-control"
                                                       type="text"
                                                       name="citationMonth"
                                                       value={formData.citationMonth}
                                                       onChange={(e) =>
                                                            setFormData(prev => ({ ...prev, citationStatus: e.target.value }))
                                                       }
                                                  />
                                             </div>
                                             <div className="col-8">
                                                  <input
                                                       className="form-control"
                                                       type="text"
                                                       name="citationDay"
                                                       value={formData.citationDay}
                                                       onChange={(e) =>
                                                            setFormData(prev => ({ ...prev, citationStatus: e.target.value }))
                                                       }
                                                  />
                                             </div>
                                             <div className="col-20 d-flex align-items-center">
                                                  <div className="flex-shrink-0 ps-3 me-1 fw-bold">Indexed</div>
                                                  <div className="flex-grow-1">
                                                       <select
                                                            id="citationIndexed"
                                                            className="form-select w-100"
                                                            name="citationIndexed"
                                                            value={formData.citationIndexed ?? ""}
                                                            onChange={(e) =>
                                                                 setFormData((prev) => ({ ...prev, citationIndexed: e.target.value }))
                                                            }
                                                       >
                                                            <option value="" disabled>Indexed</option>
                                                            <option value="Yes">Yes</option>
                                                            <option value="No">No</option>
                                                            <option value="IND">IND</option>
                                                            <option value="ER">ER</option>
                                                       </select>
                                                  </div>
                                             </div>




                                        </div>
                                   </div>

                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Citation Value</label>
                                        <select
                                             className="form-control"
                                             name="CitationValue"
                                             value={formData.CitationValue}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, CitationValue: e.target.value }))
                                             }
                                        >
                                             <option value="Very High">Very High</option>
                                             <option value="High">High</option>
                                             <option value="Medium">Medium</option>
                                             <option value="Low">Low</option>
                                             <option value="Unknown">Unknown</option>
                                        </select>
                                   </div>
                              </div>

                              {/* Row 3 (add more fields here) */}
                              <div className="row g-3 mb-3">

                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Business Name</label>
                                        <div className="col-24">
                                             <input
                                                  className="form-control"
                                                  type="text"
                                                  name="BusinessName"
                                                  value={formData.BusinessName}
                                                  onChange={(e) =>
                                                       setFormData(prev => ({ ...prev, BusinessName: e.target.value }))
                                                  }
                                             />
                                        </div>
                                        <div className="flex-grow-1 alert-success">
                                             <div className="btn btn-primary w-100" onClick={() => fillDataFromAccount()}>Complete</div>
                                        </div>

                                   </div>
                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Nap Problem</label>
                                        <div className="col-24">
                                             <input
                                                  readOnly
                                                  className={`form-control ${formData.BusinessNameIssue?.toLowerCase() === 'yes' ? 'is-invalid' : ''}`}
                                                  type="text"
                                                  name="BusinessNameIssue"
                                                  value={formData.BusinessNameIssue !== '' ? 'Yes' : 'No'}
                                             />
                                        </div>
                                        <div className="flex-grow-1">
                                             <div className="btn btn-primary w-100" onClick={() => verifyNAPData()}>Verify</div>
                                        </div>

                                   </div>
                              </div>
                              {/* Row 4 (add more fields here) */}
                              <div className="row g-3 mb-3">
                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Business Address</label>
                                        <input
                                             className={`form-control`}
                                             type="text"
                                             name="cistationAddress"
                                             value={formData.cistationAddress}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, cistationAddress: e.target.value }))
                                             }
                                        />
                                   </div>
                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Nap Problem</label>
                                        <div className="col-24">
                                             <input
                                                  readOnly
                                                  className={`form-control ${formData.Address_Issue?.toLowerCase() === 'yes' ? 'is-invalid' : ''}`}
                                                  type="text"
                                                  name="Address_Issue"
                                                  value={formData.Address_Issue !== '' ? 'Yes' : 'No'}
                                             />
                                        </div>
                                        <div className="flex-grow-1">
                                             <div className="btn btn-primary w-100" onClick={() => verifyNAPData()}>Verify</div>
                                        </div>
                                   </div>
                              </div>
                              {/* Row 5 (add more fields here) */}
                              <div className="row g-3 mb-3">
                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Postal Code</label>
                                        <input
                                             className="form-control"
                                             type="text"
                                             name="PostalCode"
                                             value={formData.PostalCode}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, PostalCode: e.target.value }))
                                             }
                                        />
                                   </div>
                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Nap Problem</label>
                                        <div className="col-24">
                                             <input
                                                  readOnly
                                                  className={`form-control ${formData.PostalCodeIssue?.toLowerCase() === 'yes' ? 'is-invalid' : ''}`}
                                                  type="text"
                                                  name="PostalCodeIssue"
                                                  value={formData.PostalCodeIssue !== '' ? 'Yes' : 'No'}
                                             />
                                        </div>
                                        <div className="flex-grow-1">
                                             <div className="btn btn-primary w-100" onClick={() => verifyNAPData()}>Verify</div>
                                        </div>
                                   </div>
                              </div>
                              {/* Row 6 (add more fields here) */}
                              <div className="row g-3 mb-3">
                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Phone Number</label>
                                        <input
                                             className="form-control"
                                             type="text"
                                             name="PhoneNumber"
                                             value={formData.PhoneNumber}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, PhoneNumber: e.target.value }))
                                             }
                                        />
                                   </div>
                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Nap Problem</label>
                                        <div className="col-24">
                                             <input
                                                  readOnly
                                                  className={`form-control ${formData.PhoneNumberIssue?.toLowerCase() === 'yes' ? 'is-invalid' : ''}`}
                                                  type="text"
                                                  name="PhoneNumberIssue"
                                                  value={formData.PhoneNumberIssue !== '' ? 'Yes' : 'No'}
                                             />
                                        </div>
                                        <div className="flex-grow-1">
                                             <div className="btn btn-primary w-100" onClick={() => verifyNAPData()}>Verify</div>
                                        </div>
                                   </div>
                              </div>
                              {/* Row 7 (add more fields here) */}
                              <div className="row g-3 mb-3">
                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Citation Link</label>
                                        <input
                                             className="form-control"
                                             type="text"
                                             name="CitationLink"
                                             value={formData.CitationLink}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, CitationLink: e.target.value }))
                                             }
                                        />
                                        <div
                                             className={`btn ${copyClicked === 'CitationLink' ? 'btn-warning' : 'btn-navy'}`}
                                             onClick={() => handleCopy('CitationLink', formData.CitationLink)}
                                        >
                                             Copy
                                        </div>
                                   </div>
                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Citation Site</label>
                                        <select
                                             className="form-control"
                                             name=" source"
                                             value={formData.source !== 'Monday' ? 'BrightLocal' : 'Monday'}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, source: e.target.value }))
                                             }
                                        >
                                             <option value="BrightLocal">Bright Local</option>
                                             <option value="Monday">Monday.com</option>
                                        </select>
                                   </div>
                              </div>

                              {/* Row 8 (Citation User Info) */}
                              <div className="d-flex g-3 mb-3 flex-wrap alert-navy p-3">
                                   <div className="col-24 d-flex align-items-center gap-2 mb-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">User</label>
                                        <input
                                             className="form-control"
                                             type="text"
                                             name="citationUser"
                                             value={formData.citationUser}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, citationUser: e.target.value }))
                                             }
                                        />
                                        <div
                                             className={`btn ${copyClicked === 'citationUser' ? 'btn-warning' : 'btn-navy'}`}
                                             onClick={() => handleCopy('citationUser', formData.citationUser)}
                                        >
                                             Copy
                                        </div>
                                   </div>
                                   <div className="col-24 d-flex align-items-center gap-2 mb-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Pass</label>
                                        <input
                                             className="form-control"
                                             type="text"
                                             name="citationPass"
                                             value={formData.citationPass}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, citationPass: e.target.value }))
                                             }
                                        />
                                        <div
                                             className={`btn ${copyClicked === 'citationPass' ? 'btn-warning' : 'btn-navy'}`}
                                             onClick={() => handleCopy('citationPass', formData.citationPass)}
                                        >
                                             Copy
                                        </div>
                                   </div>
                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">email</label>
                                        <input
                                             className="form-control"
                                             type="text"
                                             name=" citationEmail"
                                             value={formData.citationEmail}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, citationEmail: e.target.value }))
                                             }
                                        />
                                        <div
                                             className={`btn ${copyClicked === 'citationEmail' ? 'btn-warning' : 'btn-navy'}`}
                                             onClick={() => handleCopy('citationEmail', formData.citationEmail)}
                                        >
                                             Copy
                                        </div>
                                   </div>
                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Get Email</label>
                                        <input
                                             className="form-control"
                                             type="text"
                                             name="citationEmailLocation"
                                             value={formData.citationEmailLocation}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, citationEmailLocation: e.target.value }))
                                             }
                                        />
                                        <div
                                             className={`btn ${copyClicked === 'citationEmailLocation' ? 'btn-warning' : 'btn-navy'}`}
                                             onClick={() => handleCopy('citationEmailLocation', formData.citationEmailLocation)}
                                        >
                                             Copy
                                        </div>
                                   </div>
                              </div>
                              {/* Row 9 (Note field) */}
                              <div className="row g-3 mb-3 mt-3">
                                   <div className="col-48 ps-3">
                                        <label className='fw-bold'>Note</label>
                                   </div>
                                   <div className="col-48 d-flex align-items-center gap-2">
                                        <textarea
                                             className='form-control'
                                             name="Notes"
                                             id="Notes"
                                             rows="6"
                                             value={formData.Notes}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, Notes: e.target.value }))
                                             }
                                        />
                                   </div>
                              </div>

                         </>
                    )}

                    <div className="custom-modal-footer d-flex justify-content-end align-items-center gap-2 mt-4">
                         <div className="col-24 d-flex align-items-center">
                              Will put follow up Calendar
                              {/* <div className="fw-bold pe-3">Follow Up Date</div>
                              <div className="form-control p-0 border-0">
                                   <DayPicker
                                        mode="single"
                                        selected={formData.followUpDate}
                                        onSelect={(date) => setFormData((prev) => ({ ...prev, followUpDate: date }))}
                                        className="border rounded shadow-sm"
                                        footer={null}
                                   />
                              </div> */}
                         </div>
                         <div className="col-24 d-flex gap-2 justify-content-end pe-2">
                              <button className="btn btn-danger" onClick={onClose}>Cancel</button>
                              <button className="btn btn-success text-light fw-bold" onClick={() => handleSave()}>Save Changes</button>
                         </div>
                    </div>
               </div>
          </div>

     );
};

export default EditCitationModal;
